const californiaNemProviders: any = {
    'Pacific Gas & Electric Co': 'PG&E - Pacific Gas & Electric',
    'Southern California Edison Co': 'SCE - Southern California Edison',
    'San Diego Gas & Electric Co': 'SDG&E - San Diego Gas & Electric'
};

export default californiaNemProviders;